import { render, staticRenderFns } from "./FormularioManage.vue?vue&type=template&id=330f5876&scoped=true"
import script from "./FormularioManage.vue?vue&type=script&lang=js"
export * from "./FormularioManage.vue?vue&type=script&lang=js"
import style0 from "./FormularioManage.vue?vue&type=style&index=0&id=330f5876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330f5876",
  null
  
)

export default component.exports